<template>
  <div class="col-xs-12 col-lg-6">
    <div class="form-group">
      <label>{{label}}</label>
      <input :type="inputType" v-if="inputType === 'text' || inputType === 'password'" class="form-control" v-model="mData" 
        :placeholder="placeholder" v-validate="validateRule" :name="modelKey" :disabled="disabled">
      <div class="radio min-radio" v-if="inputType === 'radio'">
        <label>
          <input :type="inputType" :name="modelKey" :value="true" v-model="mData" :disabled="disabled">
          {{radioYes}}
        </label>
        <label>
          <input :type="inputType" :name="modelKey" :value="false" v-model="mData" :disabled="disabled">
          {{radioNo}}
        </label>
      </div>
      <select class="form-control" v-if="inputType === 'select'" v-model="mData"
        v-validate="validateRule" :name="modelKey" :disabled="disabled">
        <option v-for="item in selectData" :value="item.value">{{item.text}}</option>
      </select>
      <div class="err-tips" v-if="errors.has(modelKey)">{{errTips}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    errTips: {
      type: String,
      default: ''
    },
    data: {
      default: null
    },
    modelKey: {
      type: String,
      default: ''
    },
    validateRule: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    radioYes: {
      default: '',
    },
    radioNo: {
      default: '',
    },
    selectData: {
      type: Array,
      default: null
    },
  },
  computed: {
    mData: {
      get() {
        return this.data
      },
      set(val) {
        this.$emit('changeData', val, this.modelKey)
      }
    }
  },
}
</script>


<style lang="scss" scoped>
.form-group{
  padding-bottom: 20px;
  margin-bottom: 10px;
  position: relative;
  .err-tips{
    position: absolute;
    bottom: 0;
    left: 0;
    color: #f44336;
  }
  .min-radio{
    height: 34px;
    padding: 6px 12px;
    margin-top: 0;
    label{
      margin-right: 50px;
    }
    label:last-child{
      margin-right: 0;
    }
  }
} 
</style>




// WEBPACK FOOTER //
// src/components/inputModel.vue